import { useState } from 'react';
import LegalModal from '@/components/LegalModal';
import { termsAndConditions, aiDisclaimer } from '@/lib/legalContent';

import { useLang } from '@/lib/LanguageContext';

export default function StepSummary({ data, agreed, setAgreed, onEditStep }) {
  const { t } = useLang();
  const [legalView, setLegalView] = useState(null); // 'terms' | 'ai'

  const Row = ({ label, value, step }) => (
    <div className="flex items-start justify-between gap-4 py-1.5 border-b border-border/30 last:border-0">
      <div className="min-w-0">
        <p className="text-xs text-muted-foreground uppercase tracking-wider">{t(label)}</p>
        <p className="text-sm text-foreground font-inter mt-0.5 whitespace-pre-wrap break-words">{value || '—'}</p>
      </div>
      <button type="button" onClick={() => onEditStep(step)} className="text-xs text-primary hover:underline shrink-0">{t('Edit')}</button>
    </div>
  );

  return (
    <div className="space-y-4">
      <div className="rounded-xl border border-border/50 bg-secondary/20 p-4">
        <Row label="Name" value={data.name} step={1} />
        <Row label="Email" value={data.email} step={1} />
        <Row label="Phone" value={data.phone} step={1} />
        <Row label="Project Type(s)" value={(data.project_types || []).map(t).join(', ')} step={1} />
        <Row label="Description" value={data.description} step={2} />
        <Row label="Budget" value={data.budget} step={2} />
      </div>

      <label className="flex items-start gap-3 text-sm text-muted-foreground font-inter cursor-pointer">
        <input type="checkbox" checked={agreed} onChange={(e) => setAgreed(e.target.checked)} className="mt-1 accent-primary" />
        <span>
          {t('I accept the')}{' '}
          <button type="button" onClick={() => setLegalView('terms')} className="text-primary hover:underline">{t('Terms & Conditions')}</button>
          {' '}{t('and the')}{' '}
          <button type="button" onClick={() => setLegalView('ai')} className="text-primary hover:underline">{t('AI Disclaimer')}</button>.
        </span>
      </label>

      {legalView === 'terms' && (
        <LegalModal {...termsAndConditions} onClose={() => setLegalView(null)} />
      )}
      {legalView === 'ai' && (
        <LegalModal {...aiDisclaimer} onClose={() => setLegalView(null)} />
      )}
    </div>
  );
}